import { render, staticRenderFns } from "./userDownloadGuide.vue?vue&type=template&id=4fc8741c&"
import script from "./userDownloadGuide.vue?vue&type=script&lang=js&"
export * from "./userDownloadGuide.vue?vue&type=script&lang=js&"
import style0 from "./userDownloadGuide.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports